import NewApiService from "@/utils/new.api.service";

export default {
    list(ctx, params) {
        const {pagination, search, filters, expand} = params

        var filter = [];
        Object.keys(filters).forEach((key) => {
            filter[key] = filters[key]
        });

        let sort = pagination.sortBy ? pagination.sortBy[0] : null;

        if(pagination.sortDesc && pagination.sortDesc[0] == false){
            sort = '-'+sort;
        }
        let page = pagination.page
        let rows_per_page = pagination.itemsPerPage

        return new Promise((resolve, reject) => {
            NewApiService.get("supplier", {
                sort, page, search, filter, expand, rows_per_page
              })
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },

    allSuppliers(ctx) {
        return new Promise((resolve, reject) => {
            NewApiService.get("supplier", {"rows_per_page": 0})
            .then(({data}) => {
                ctx.commit("set_list", data.suppliers);
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },

    products(ctx, supplierId ) {
        return new Promise((resolve, reject) => {
            NewApiService.get(`supplier/${supplierId}/products`)
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },

    productsLowStock(ctx, { id, page, rows_per_page } ) {
        return new Promise((resolve, reject) => {
            NewApiService.get(`supplier/${id}/products-low`,{
                page, rows_per_page
            })
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },
    

    productsPending(ctx, { id, page, rows_per_page } ) {
        return new Promise((resolve, reject) => {
            NewApiService.get(`supplier/${id}/products-pending`,{
                page, rows_per_page
            })
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },
    
    view(ctx, supplierId) {
        return new Promise((resolve, reject) => {
            NewApiService.get("supplier/"+supplierId)
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },


    create(ctx, model) {
        return new Promise((resolve, reject) => {
            NewApiService.post("supplier",model)
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },
    
    update(ctx, model) {
        return new Promise((resolve, reject) => {
            NewApiService.put("supplier/"+model.id,model)
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },
    
    delete(ctx, model) {
        return new Promise((resolve, reject) => {
            NewApiService.delete("supplier/"+model.id)
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    }
    
}